import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { JOURNEY } from 'routes/constants'
import CommonDialog from '../../notificationOverlay/CommonDialog'
import InCardStack from 'components/atoms/container/InCardStack'
import { Typography } from '@mui/material'

const StartnewPathDialog = ({ open, setOpen, goalName }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  return (
    <CommonDialog
      titleText={t('home.newLearningPathAssignment')}
      open={open}
      confirmText={t('home.startMyPath')}
      onClose={confirmed => (confirmed ? navigate(JOURNEY) : setOpen(false))}>
      <InCardStack>
        <Typography component='div'>
          <Typography>{t('home.companyAssignedYouNewLearningPath')}</Typography>
          <Typography fontWeight='bold' textAlign='center'>
            {goalName}
          </Typography>
        </Typography>
        <Typography textAlign='center'>
          {t('home.automaticallyTakenToSelfAssessment')}
        </Typography>
        <Typography>{t('home.clickStartToBegin')}</Typography>
      </InCardStack>
    </CommonDialog>
  )
}

export default StartnewPathDialog
